import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import CallInfo from '../../component/CallInfo';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import AccountList from '../../component/Account/AccountList';
import Information from '../../component/Information';
import Main_Spring from '../../component/Spring/Main_Spring';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import ParentInfo from '../../component/Info/ParentInfo';
import musicTitle from '../../asset/music/winter.mp3'

const LeeSooJin2 = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "손두영❤️이수진 결혼합니다.";
    const openDesc = "2025년 9월 6일 오후 3시 30분";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/285/thumb.jpg";

    const lng = 126.996539280573
    const lat = 37.4989346582652 ;

    const placeTelNum = "02-6243-6000";

    const forCar = "네비게이션 주소검색 \n· 신주소 서초구 사평대로 108\n· 구주소 서초구 반포동 107-3";
    const forParking = "건물 내 만차 시 외부 주차장 안내\n(도보 10분 거리, 셔틀 수시 운행)\n\n- 주차공간이 협소하오니 되도록 대중교통을 이용해주시기 바랍니다.\n- 외부 주차장 이동으로 인해 시간을 여유롭게 출발해주시기 바랍니다.";
    const forSubway = "9호선 신반포역 4번 출구(반포종합운동장 방향 도보 7분, \n셔틀버스 수시 운행)";

    {/* const parents = [
        {groom : "김두희 · 이연숙의 장남"},
        {bride : "❁이석원 · 박영란의 차녀"}
    ] */}

    // const parentInfo = {
    //     groom: {
    //         dad: { name: "명남식", isDeceased: false },
    //         mom: { name: "안인순", isDeceased: true },
    //         role: "아들",
    //     },
    //     bride: {
    //         dad: { name: "이금하", isDeceased: false },
    //         mom: { name: "구은숙", isDeceased: false },
    //         role: "딸",
    //     }
    // };

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // 블루A #9FB4E7
        // 연퍼플 #e4aced
    // 빈티지 연퍼플 #bf9cd8
    // 소라 : #88abd1
    // #edacb1
    // #D77599
    // #BC5078
    // #ff8faf
    // 레몬 옐로우 #EFD140
    // #EB9217
    // 빈티지 옐로우 : #EAC63C
    // #FC62A4
    // #f5408d
    // #ffb0d2 쿨 연핑크
    // 핑크A #FF8A83, #FFE8E7
    // 핑크B #ff8faf, #ffcfe1
    // 옐로우 #ffd139,  #ffe49f
    // #DAA708
    // #B4CCF1
    const conceptStyle = {
        // spring 핑크A
        concept: "SPRING",
        titleColor: "#FF8A83",
        pointColor: "#FF8A83",
        btnBgColor: "#FFE8E7",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#fff5f9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const infoTitle = "♡우리 결혼합니다♡";


    const msg1 = "곁에 있을 때 가장 나다운 모습이 되게하는 사람과 \n서로의 모든 계절을 함께하고자 합니다.";
    const msg2 = "언제나처럼 평생의 친구이자\n서로에게 유일한 사람으로 머물겠습니다."
    const msg3 = "찬란한 저희의 날, \n늘 곁에서 아껴주셨던 소중한 분들을 모십니다.";


    const groomAccountList = [
        {
            role: "신랑",
            name: "손두영",
            bank: "신한은행",
            accountNumber : "110-448-947051",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej7n8XpSh"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "ㅇㅇㅇ",
        //     bank: "농협은행",
        //     accountNumber : "",
        //     isKakao : false
        // }
        // ,{
        //     role: "신랑 모",
        //     name: "ㅇㅇㅇ",
        //     bank: "농협은행",
        //     accountNumber : "",
        //     isKakao : false
        // }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "이수진",
            bank: "국민은행",
            accountNumber : "618701-04-199830",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FcDOltYxa"
        }
        ,{
            role: "신부 부",
            name: "이재경",
            bank: "대구은행",
            accountNumber : "508-12-6043434",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "박미옥",
            bank: "농협은행",
            accountNumber : "728-12-131568",
            isKakao : false
        }
    ]


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "손두영",
            call: "010-6877-2210"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "ㅇㅇㅇ",
        //     call: ""
        // }
        // ,{
        //     role: "신랑 모",
        //     name: "ㅇㅇㅇ",
        //     call: ""
        // }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "이수진",
            call: "10-8670-8656"
        }
        // ,{
        //     role: "신부 부",
        //     name: "ㅇㅇㅇ",
        //     call: ""
        // },
        // {
        //     role: "신부 모",
        //     name: "ㅇㅇㅇ",
        //     call: ""
        // }
    ]

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "깜짝 놀랐지",
            brideAnswer: "너무 떨렸어"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "너무 설레어",
            brideAnswer: "두근두근해"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "행복을 줄게",
            brideAnswer: "사랑을 줄게"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "당신만 볼게",
            brideAnswer: "우리 잘 살자"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "사랑할게요",
            brideAnswer: "오래오래❤️"
        }
    ]

    const informationList =[
        {
            title : "피로연 안내",
            content : "장소: 보성녹차떡갈비원조\n주소: 전남 보성군 보성읍 흥성로 2541-4\n일시: 9월 5일(금요일) 11시~14시까지"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#FF8A83"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter title={infoTitle} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    <CallInfo marginTop={"0px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>    
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>    
                    <MotionWrapper initialY={50}>
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>    
                    <Location_Desc forCar={forCar} forSubway={forSubway} forParking={forParking} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default LeeSooJin2;